import { FC, useEffect } from 'react';
import { Box } from '@mui/material';
import { useFormContext } from 'react-hook-form-mui';
import { Input } from 'view/components';

interface ISalaryRangeProps {
  fromValue: string;
  toValue: string;
  onChange: (field: 'from' | 'to', value: string) => void;
  label?: string;
}

const SalaryRange: FC<ISalaryRangeProps> = ({
  fromValue,
  toValue,
  onChange,
  label = 'Salary Range ($)',
}) => {
  const {
    trigger,
    clearErrors,
    /* formState: { errors }, */
  } = useFormContext();

  useEffect(() => {
    if (!fromValue || !toValue) clearErrors(['salaryRange.from', 'salaryRange.to']);
    if (fromValue || toValue) {
      trigger('salaryRange.from').then();
      trigger('salaryRange.to').then();

      if (Number(fromValue) <= Number(toValue)) {
        clearErrors(['salaryRange.from', 'salaryRange.to']);
      }
    }
  }, [fromValue, toValue, trigger, clearErrors]);

  return (
    <Box display="flex" alignItems="center" gap={1}>
      <Box display="flex" alignItems="center" gap={1}>
        <Input
          name="salaryRange.from"
          label={label}
          placeholder="From"
          type="text"
          marginbottom={1}
          value={fromValue}
          onChange={(e) => {
            return onChange('from', e.target.value.replace(/\D/g, ''));
          }}
          rules={{
            pattern: { value: /^[0-9]*$/, message: 'Only numbers are allowed' },
            validate: (value) => {
              return toValue && Number(value) > Number(toValue)
                ? 'From must be less than To'
                : true;
            },
          }}
          helperText=" "
        />
        <span>-</span>
        <Input
          name="salaryRange.to"
          label=" "
          placeholder="To"
          type="text"
          marginbottom={1}
          value={toValue}
          onChange={(e) => {
            return onChange('to', e.target.value.replace(/\D/g, ''));
          }}
          rules={{
            pattern: { value: /^[0-9]*$/, message: 'Only numbers are allowed' },
            validate: (value) => {
              return fromValue && Number(value) < Number(fromValue)
                ? 'To must be greater than From'
                : true;
            },
          }}
          helperText=" "
        />
      </Box>
    </Box>
  );
};

export default SalaryRange;
